module.exports = __webpack_public_path__ + "img/06021.b54ebd9a.png";